// extracted by mini-css-extract-plugin
module.exports = {"base_info":"dece2e673c--base_info--dn5bz","price_info":"dece2e673c--price_info--PG11v"};